import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const postNewCertificate = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.CERTIFICATE_MANAGEMENT.POST_NEW_CERTIFICATE,
    data
  );
};

export default postNewCertificate;
